module.exports = __webpack_public_path__ + "img/homepage-banner.0de50655.png";